// extracted by mini-css-extract-plugin
export default {"skillsSelect":"skills_section-module___skillsSelect___bd0286e9"};